import { VITALL_SYSTEM } from '@constants/extension-codes';

import { formatFhirDate } from '@utils/fhir';

import type { CodeableConcept, RiskAssessmentModel } from 'generated/types';

import { FhirResource } from './fhir-resource';

export class RiskAssessmentRecord extends FhirResource {
  protected model: RiskAssessmentModel;

  public constructor(model: RiskAssessmentModel) {
    super(model);
    this.model = model;
  }

  public get assessmentDate() {
    return formatFhirDate(this.model.occurrenceDateTime, { adjustTz: true });
  }

  public get assessmentType() {
    return this.model.method?.coding?.map(({ code }) => code).join(',');
  }

  public get predictions() {
    const assmntPredictions = this.model.prediction?.map(
      ({ outcome, probabilityDecimal, qualitativeRisk, relativeRisk }) => {
        return {
          code: this.getVitallCode(outcome ?? undefined),
          risk: this.getRiskLevel(qualitativeRisk ?? undefined),
          value: probabilityDecimal ?? relativeRisk,
        };
      }
    );
    return assmntPredictions;
  }

  public getVitallCode(codes?: CodeableConcept) {
    const vitallCode = codes?.coding?.find(
      ({ system }) => system === VITALL_SYSTEM
    )?.code;
    return vitallCode ?? codes?.text;
  }

  public getRiskLevel(risks?: CodeableConcept) {
    const risk = risks?.coding?.at(0);
    return risk?.code;
  }

  public getObservations() {
    return this.model.observations ?? [];
  }
}
